// mobile menu

var triggers = document.querySelectorAll(".js-toggle-sub-menu");

for (const trigger of triggers) {
  trigger.addEventListener("click", function () {
    this.classList.toggle("sub-menu--open");


    let aria_status = jQuery(this).next().attr("aria-expanded")

    if (aria_status == 'false') {
      aria_status = 'true'
    } else {
      aria_status = 'false'
    }

    jQuery(this).next().attr('aria-expanded', aria_status)
  });
}


if (document.querySelector(".js-open-mm")) {
  var trigger = document.querySelector(".js-open-mm");
  trigger.addEventListener("click", function () {
    document.body.classList.add("mm--open");

    setTimeout(function () {
      document.querySelector('.js-mm-search').focus()
    }, 150)
  });

}

if (document.querySelector(".js-close-mm")) {
  var trigger = document.querySelector(".js-close-mm");
  trigger.addEventListener("click", function () {
    document.body.classList.remove("mm--open");
  });
}
